// Lightweight client error reporter. Logs to console and exposes an optional
// global hook (`window.__appErrorBus.captureException`) that monitoring tools
// can plug into without coupling the app to a specific vendor.

type ErrorReporterOptions = {
  mechanism?: "manual" | "onerror" | "unhandledrejection" | "react_error_boundary";
  handled?: boolean;
  severity?: "error" | "warning" | "info";
};

type AppErrorBus = {
  captureException?: (
    error: unknown,
    context?: Record<string, unknown>,
    options?: ErrorReporterOptions,
  ) => void;
};

declare global {
  interface Window {
    __appErrorBus?: AppErrorBus;
  }
}

export function reportClientError(error: unknown, context: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  try {
    window.__appErrorBus?.captureException?.(
      error,
      { source: "react_error_boundary", route: window.location.pathname, ...context },
      { mechanism: "react_error_boundary", handled: false, severity: "error" },
    );
  } catch {
    // Reporter must never throw inside an error boundary.
  }
  if (typeof console !== "undefined") console.error(error);
}